module.exports = __webpack_public_path__ + "fonts/Inter-300-latin24.5eb4a77.woff2";